// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Text } from '@mantine/core';
import { useContext } from 'react';
import BookitupNumberInput from '../../../Atoms/inputs/BookitupNumberInput';
import { ThemeText } from '../../../Atoms/ThemeText';
import { DocumentTemplateContext } from '../../../Service/Context/DocumentTemplateContext';

const DistancePolicySettings = () => {
  const { bookitupDocument, savePatch } = useContext(DocumentTemplateContext);
  const { freeKms, freeKmsThreshold } = bookitupDocument ?? {};

  if (!bookitupDocument) {
    return null;
  }

  return (
    <>
      <ThemeText mt="xs" mb="sm">Anzahl der Kilometer, für die Du keine Anfahrt berechnen möchtest.</ThemeText>
      <BookitupNumberInput
        hideControls
        label="Frei-Kilometer"
        min={0}
        defaultValue={freeKms ?? 0}
        sx={{ maxWidth: 250 }}
        rightSection={
          <ThemeText size="xs" weight="bolder" mr={5}>
            km
          </ThemeText>
        }
        onBlurSave={(val) => savePatch({ freeKms: Number(val) })}
      />
      <Text color="dimmed" size="xs">
        ➡️ Beispiel: Bei „50“ werden bis zu 50 km nicht berechnet.
      </Text>
      <ThemeText mt="xl">
        Ab wie vielen zusätzlichen Kilometern sollen die Fahrtkosten dann berechnet werden sollen.
      </ThemeText>
      <BookitupNumberInput
        hideControls
        min={0}
        mt="sm"
        rightSection={
          <ThemeText size="xs" weight="bolder" mr={5}>
            km
          </ThemeText>
        }
        label="Schwelle für Fahrtkosten"
        value={freeKmsThreshold ?? 0}
        sx={{ maxWidth: 250 }}
        onBlurSave={(val) => savePatch({ freeKmsThreshold: Number(val) })}
      />
      <Text color="dimmed" size="xs">
        ➡️ Beispiel: Bei „10“ werden Fahrtkosten erst berechnet, wenn nach Abzug der Frei-Kilometer (s. Feld oben) mehr
        als 10 km übrig bleiben.
      </Text>
    </>
  );
};

export default DistancePolicySettings;
